import FleurKintsugi from "../brand/FleurKintsugi";
import KintsugiScrollVein from "../brand/KintsugiScrollVein";
import Reveal from "./Reveal";
import ShareButtons from "../ShareButtons";

export default function StoryHero({ name, title, quote, portrait }) {
  return (
    <section className="relative overflow-hidden" data-testid="story-hero">
      <div className="magma-ambient" aria-hidden="true"><span className="magma-blob" /></div>
      <KintsugiScrollVein variant="s-curve" strokes={2} opacity={0.5} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pt-16 lg:pt-24 pb-12 lg:pb-20 grid lg:grid-cols-[1.1fr_0.9fr] gap-12 lg:gap-16 items-center">
        <div className="hidden lg:block absolute left-2 top-1/2 -translate-y-1/2 vertical-mark" aria-hidden="true">
          Mon histoire · Saveurs Normandes · Louviers
        </div>

        <div className="lg:pl-10">
          <div className="smallcaps-label reveal-hero mb-6" style={{ animationDelay: "0.1s" }} data-testid="story-eyebrow">
            Mon histoire
          </div>
          <h1
            className="font-display leading-[0.95] tracking-tight reveal-hero"
            style={{ fontSize: "clamp(2.8rem, 7vw, 6rem)", animationDelay: "0.25s" }}
            data-testid="story-name"
          >
            <span className="block text-foreground/90 uppercase">{name.split(" ")[0]}</span>
            <span className="block gold-text uppercase">{name.split(" ").slice(1).join(" ")}</span>
          </h1>
          <p
            className="font-display text-lg md:text-xl text-foreground/80 mt-8 max-w-xl leading-snug reveal-hero"
            style={{ animationDelay: "0.45s" }}
            data-testid="story-title"
          >
            {title}
          </p>
          <div className="kintsugi-divider my-8 reveal-hero" style={{ margin: "2rem 0", maxWidth: "9rem", animationDelay: "0.6s" }} />
          <blockquote
            className="font-vibes molten-flow leading-[1.15] magma-halo reveal-hero"
            style={{ fontSize: "clamp(1.9rem, 3.4vw, 2.7rem)", animationDelay: "0.75s" }}
            data-testid="story-lead-quote"
          >
            « {quote} »
          </blockquote>
          <ShareButtons sharePath="mon-histoire" title={`Mon histoire — ${name} · Saveurs Normandes`} text={title} className="mt-10 reveal-hero" />
        </div>

        <Reveal className="relative" delay={300}>
          <div className="kintsugi-frame aspect-[4/5] w-full max-w-md mx-auto lg:max-w-none" data-testid="story-portrait">
            <img src={portrait} alt={name} loading="eager" />
          </div>
          <div className="absolute -bottom-12 left-0 flex items-center gap-4" aria-hidden="true">
            <FleurKintsugi size={40} />
            <span className="font-vibes text-3xl gold-text">Créateur d'arrangés</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
